import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {getFlatCode, isEmpty} from "../../../components/commonmethod/CommonMethod";
import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailFormTabChrome,
    DetailKvTable,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import Th_title from "../../../components/Th_title";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import {useDispatch, useSelector} from "react-redux";
import {
    changeProgressStatusValue,
    changeStatusNumericValue,
} from "../../../redux/slice/contentSlice";
import {
    clearApprovalProcessState,
    getApprovalProcessSubmitPayload,
    preloadApprovalProcessFromFlatCode,
} from "../../settings/approval/shared/approvalProcessStore";
import {CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {apiLoading, skeleton} from "../../../redux/slice/apiSlice";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import Selector from "../../../components/selector/Selector";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsInput from "../../../components/input/SimmsInput";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {getIntroduction, updateIntroduction} from "../../../api/lifecycle/introduction/IntroductionService";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import {handleActiveError} from "../../../components/sonner/ToastBasic";
import {selectCodesByParentId} from "../../../api/code/CodeService";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import {assetNameDuplicate} from "../../../api/asset/AssetService";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {IntroductionAssetDraftList} from "./components/IntroductionAssetDraftList";
function IntroductionUpdate(){
    const {id} = useParams();
    const dispatch = useDispatch();
    const [introduction, setIntroduction] = useState({});
    const [flatCode, setFlatCode] = useState([]);
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);

    const location = useLocation();
    const navigate = useNavigate();

    const goToDetail = () => navigate(`/lifecycle/introduction/${id}`);

    useEffect(() =>{
        Promise.all([
            getIntroduction(id),
            getContentStatus({contentId : id, contentCategory : ContentCategory.INTRODUCTION})
        ]).then(([ introductionResponse, statusNumericValueResponse]) => {
            if(introductionResponse.status === 201) {
                if (introductionResponse.data.errorCode = 'AUTHORITY') {
                    alert(introductionResponse.data.reason)
                    navigate(-1)
                }
            }

            setIntroduction(introductionResponse.data);

            if (statusNumericValueResponse && statusNumericValueResponse.status === 200) {
                const numericValue = statusNumericValueResponse.data.statusNumericValue;
                dispatch(changeStatusNumericValue(numericValue));
                dispatch(changeProgressStatusValue(statusNumericValueResponse.data));
            }

            return selectCodesByParentId(CodeSpecNum.IntroductionRequestCode)
                .then(codes => {
                    setFlatCode(getFlatCode(codes));
                })
        }).finally(
            dispatch(skeleton(false))
        )
    }, [id, dispatch])

    useEffect(() => {
        clearApprovalProcessState(dispatch);
        return () => clearApprovalProcessState(dispatch);
    }, [dispatch, id]);

    useEffect(() => {
        if (!introduction.requestCode?.id || flatCode.length === 0) return;
        preloadApprovalProcessFromFlatCode(dispatch, introduction.requestCode.id, flatCode, { includeAfter: false });
    }, [introduction.requestCode?.id, flatCode, dispatch]);

    const requireds =["name","requester", "inspector", "requestCode"]
    const update = async ()=>{
        if(introduction.assets.length == 0){
            alert("자산을 추가해주세요")
            return false;
        }

        if(requireds.some(e=> isEmpty(introduction[e]))){
            alert("필수값이 누락되었습니다.")
            return
        }

        dispatch(apiLoading(true));

        // const filteredAssets = introduction.assets.map((asset) => ({
        //     assetName: asset.assetName,
        //     group: {id: asset.group.id }
        // }));

        // const {createdBy, auth, group, ...rest} = introduction;

        const data = {
            ...introduction,
            ...getApprovalProcessSubmitPayload(),
            requester: {id: introduction.requester.id},
            inspector: {id: introduction.inspector.id},
            requestCode: {id: introduction.requestCode.id},
            ...(introduction.operator && { operator: { id: introduction.operator.id } }) // operator가 있을 때만 추가
        }

        await updateIntroduction(data).then(response => {
            if(response.status === 200){
                alert("접수되었습니다.")
                navigate("/lifecycle/introduction/"+id, {
                    state: {
                        test: location.state
                    }
                });
            }else if(response.status==201){
                handleActiveError({message: response.data.title, description: response.data.reason});
            }
        }).finally(dispatch(apiLoading(false)));
    }

    const addAssets = async () => {
        // if(!introduction.operator) {
        //     alert("운영담당자를 선택해주세요")
        //     return;
        // }

        if(!introduction.assetName) {
            alert("도입자산명을 입력해주세요")
            return;
        }

        if(!introduction.group) {
            alert("자산그룹을 선택해주세요")
            return;
        }

        if(introduction.assets.length > 0 && introduction.assets.find(each => each.assetName == introduction.assetName)) {
            alert("도입자산에 동일한 자산명이 존재합니다.")
            return;
        }

        const r = await assetNameDuplicate(introduction.assetName);
        if (r.status === 201 || (r.status === 202)) {
            alert("등록된 자산에 동일한 자산명이 존재합니다.")
            return r;
        }

        setIntroduction((prev) => {
            return {
                ...prev, // group과 operator는 유지
                assets: [
                    ...prev.assets, // 기존 asset 배열
                    {
                        assetName : prev.assetName, // assetName 추가
                        groupId : prev.group.id,
                        groupName : prev.group.name
                        // operator: prev.operator // operator 상태 그대로 추가
                    }
                ]
            };
        });
    };

    // 2. asset 배열에서 특정 인덱스의 항목 삭제
    const deleteAsset = (index) => {
        setIntroduction((prev) => ({
            ...prev,
            assets: prev.assets.filter((_, i) => i !== index) // 인덱스 제외하고 새 배열 반환
        }));
    };

    if (Object.keys(introduction).length > 0 && flatCode.length > 0) {
        const summaryMeta = [
            introduction.requestCode?.name,
            introduction.number && `번호 ${introduction.number}`,
        ]
            .filter(Boolean)
            .join(" · ");

        const requestInfoPanel = (
            <DetailPanel title="요청정보">
                <DetailKvTable>
                    <tbody>
                    <tr>
                        <Th_title title={"요청자"} colspan={3} className="fieldset-td" required auth={introduction.auth.update}>
                            <Selector
                                onChange={(v)=>onCreateClickListener(setIntroduction, "requester", introduction.requester ,v)}
                                data={introduction.requester}
                                entity={"userAccount"}
                                uniqueKey={'requester'}
                            >
                                <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                            </Selector>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청종류"} colspan={3} className="fieldset-td" required auth={introduction.auth.update}>
                            <Selector
                                onChange={(v)=>onCreateClickListener(setIntroduction, "requestCode", introduction.requestCode ,v)}
                                data={introduction.requestCode}
                                entity={"code"}
                                parentKey={CodeSpecNum.IntroductionRequestCode}
                                recursive
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청일"} colspan={3} className="fieldset-td fieldset-td-input">
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker
                                    onChange={(v)=>dateOnChange(setIntroduction,"requestStartDate", v, false)}
                                    data={introduction.requestStartDate}
                                    constraint={{lessThan : introduction.requestEndDate && dayjs(introduction.requestEndDate)}} auth={introduction.auth.update} />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker
                                    onChange={(v)=>dateOnChange(setIntroduction,"requestEndDate", v, false)}
                                    data={introduction.requestEndDate}
                                    constraint={{largerThan : introduction.requestStartDate && dayjs(introduction.requestStartDate)}} auth={introduction.auth.update} />
                            </div>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청번호"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"number"} value={introduction.number} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"검수자"} colspan={3} className="fieldset-td" auth={introduction.auth.update} required>
                            <Selector
                                onChange={(v)=>onCreateClickListener(setIntroduction, "inspector", introduction.inspector ,v)}
                                data={introduction.inspector}
                                entity={"userAccount"}
                                uniqueKey={'inspector'}
                            >
                                <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                            </Selector>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"제목"} colspan={3} className="fieldset-td" auth={introduction.auth.update} required>
                            <SimmsInput onChange={(v)=>inputOnChange(setIntroduction,"name", v, true)} data={introduction.name} style={{width: "100%"}} />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"내용"} colspan={3} className="fieldset-td" auth={introduction.auth.update}>
                            <SimmsTextArea onChange={(v)=>inputOnChange(setIntroduction,"content", v, false)}
                                           style={{width: "100%", minHeight: "80px"}}
                                           data={introduction.content} />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"기타"} colspan={3} className="fieldset-td" auth={introduction.auth.update}>
                            <SimmsTextArea onChange={(v)=>inputOnChange(setIntroduction,"etc", v, false)}
                                           style={{width: "100%", minHeight: "80px"}}
                                           data={introduction.etc} />
                        </Th_title>
                    </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        );

        const assetInfoPanel = (
            <DetailPanel title="자산정보">
                    <DetailKvTable>
                        <tbody>
                        <tr>
                            <Th_title title={"운영담당자"} colspan={3} className="fieldset-td" auth={introduction.auth.update}>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setIntroduction, "operator", introduction.operator ,v)}
                                    data={introduction.operator}
                                    entity={"userAccount"}
                                    uniqueKey={'operator'}
                                >
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                    <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                    <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                </Selector>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"자산그룹"} colspan={3} className="fieldset-td" auth={introduction.auth.update} required>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setIntroduction, "group", introduction.group ,v)}
                                    data={introduction.group}
                                    entity={"code"}
                                    parentKey={CodeSpecNum.AssetGroupCode}
                                    recursive
                                />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"도입자산 명"} colspan={3} className="fieldset-td" auth={introduction.auth.update}>
                                <div className="introduction-asset-name-field">
                                    <SimmsInput onChange={(v)=>inputOnChange(setIntroduction,"assetName", v, false)} data={introduction.assetName} />
                                    <button
                                        type="button"
                                        className="introduction-asset-name-field__add shrink-0"
                                        onClick={addAssets}
                                    >
                                        추가
                                    </button>
                                </div>
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"자산내역"} colspan={3} className="fieldset-td align-top">
                                <IntroductionAssetDraftList
                                    assets={introduction.assets}
                                    onRemove={deleteAsset}
                                />
                            </Th_title>
                        </tr>
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
        );

        const asidePanel = (
            <>
                <ApprovalComponent auth={introduction.auth.update} approvalProcessId={approvalProcessId} />
                <DetailFilePanel
                    title="첨부"
                    isEditing={Boolean(introduction.auth?.update)}
                    tableInfo={{tableName: "Introduction", joinKey: introduction.id}}
                />
            </>
        );

        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray flex min-h-0 flex-1 flex-col">
                <DetailFormTabChrome>
                    <ContentDetailInfoShell
                        title={introduction.name || "자산도입 접수"}
                        meta={summaryMeta || undefined}
                        contentId={id}
                        contentCategory={ContentCategory.INTRODUCTION}
                        scrollMode="columns"
                        actions={
                            <DetailSummaryButton muted onClick={goToDetail}>
                                취소
                            </DetailSummaryButton>
                        }
                        rollup={{
                            update: introduction.auth?.update ? update : "",
                            updateTitle: "접수완료",
                        }}
                    >
                        <ContentDetailThreeColLayout
                            primary={requestInfoPanel}
                            secondary={assetInfoPanel}
                            aside={asidePanel}
                        />
                    </ContentDetailInfoShell>
                </DetailFormTabChrome>
            </div>
        );
    }
}

export {IntroductionUpdate}